/**
 * 案件の新規登録の入口 (一覧の 2 択モーダル・動画エディタ) から登録ページ (ManualProductNewPage) へ渡す遷移の state。
 * 'url' / 'video' は読み取りパネルの経路 (video は video-editor-presentation-import-plan.md §4.6 の「動画から生成する」)。
 */
import type { UrlSummarySource } from './urlSummary';

export type ProductEntryState =
  | { entry: 'url'; url: string; wait?: boolean }
  | {
      entry: 'video';
      projectId: string;
      label: string;
      wait?: boolean;
      /** 登録が完了したら、この編集に案件を紐づけて動画エディタへ戻る (video-import-motion-scenario-plan.md §3.1) */
      returnTo?: { projectId: string };
    }
  | { entry: 'manual' };

/** 読み取りの元 → 登録ページへ渡す state */
export function entryStateOf(source: UrlSummarySource, wait?: boolean): ProductEntryState {
  return source.kind === 'video'
    ? { entry: 'video', projectId: source.projectId, label: source.label, ...(wait === undefined ? {} : { wait }) }
    : { entry: 'url', url: source.url, ...(wait === undefined ? {} : { wait }) };
}
